import { Box, Text } from '@mantine/core';
import { IconFileOff } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import AssetsCards from '../../components/Assets/AssetsCards';
import ErrorMessage from '../../components/ErrorMessage';
import Spinner from '../../components/Spinner';
import useFetch from '../../helpers/useFetch';

const ProfilesDetailsAssetsPage = ({ profile }) => {
  const [assets, setAssets] = useState();
  const [error, setError] = useState();
  const fetch = useFetch();
  const { accountId, domainId } = useParams();

  const fetchURL = `/api/admin/accounts/${accountId}/domains/${domainId}/profiles/assets`;

  useEffect(() => {
    setAssets(undefined);
    fetch(fetchURL, {
      method: 'POST',
      body: JSON.stringify({ assetsIds: profile.aiAssets }),
    })
      .then(async ({ assets }) => {
        setAssets(assets);
      })
      .catch((error) => setError(error));
  }, [fetch, fetchURL, profile.aiAssets]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (!assets) {
    return <Spinner />;
  }

  const assetCards = <AssetsCards assets={assets} />;

  return (
    <Box>
      {assets.length > 0 ? (
        assetCards
      ) : (
        <Text c="dimmed">
          <IconFileOff /> No data was found
        </Text>
      )}
    </Box>
  );
};

export default ProfilesDetailsAssetsPage;
